import tw from 'tailwind-styled-components';

export const Container = tw.div`
    pt-5
    flex
    justify-center
`;

export const Wrapper = tw.div<{ $numberOfCards: number }>`
    pt-5
    flex-column
    md:flex
    flex-wrap
    justify-center
    w-11/12
    mmd:w-3/5


    ${(p: { $numberOfCards?: number }) =>
      p.$numberOfCards === 1
        ? `
        md:w-2/5
        lg:w-1/3
        xl:w-1/4
        2xl:w-1/5
        3xl:w-1/5
        `
        : ''}

    ${(p: { $numberOfCards?: number }) =>
      p.$numberOfCards === 2
        ? `
        md:w-10/12
        lg:w-8/12
        xl:w-7/12
        2xl:w-1/2
        `
        : ''}

    ${(p: { $numberOfCards?: number }) =>
      p.$numberOfCards === 3
        ? `
        md:w-full
        lg:w-10/12
        xl:w-9/12
        2xl:w-8/12
        3xl:w-7/12
        `
        : ''}
`;

export const CardWrapper = tw.div`
    flex-1
    md:w-1/3
`;
